import React, { useState } from 'react';
import LocationSearch from '../location-search/LocationSearch';
import { Coordinates } from '../../../api/localisation/types';
import { useLocalisationContext } from '../localisation/context/LocalisationContext';
import { DeliveryLocation } from '../localisation/utils/types';

type StoreHeaderProps = {
  getLocations: (postcode: string, coordinates?: Coordinates, returnEmpty?: boolean) => void;
  setSearchData: (postcode: string, coordinates: string) => void;
};

const StoreHeader = ({ getLocations, setSearchData }: StoreHeaderProps) => {
  const { selectedStore } = useLocalisationContext();
  const [initialValue, setInitialValue] = useState(selectedStore?.aggregatedAddress || '');

  const handleStoreLookup = (location?: DeliveryLocation) => {
    if (location) {
      setInitialValue(location.displayName);
      setSearchData(location.postcode, `${location.coordinates.latitude},${location.coordinates.longitude}`);
      getLocations('', { longitude: location.coordinates.longitude, latitude: location.coordinates.latitude });
    } else {
      getLocations('', undefined, true);
    }
  };

  return (
    <div className="store-finder-header">
      <div className="store-finder-title">
        <h1>Store Finder</h1>
      </div>
      <div className="store-finder-search">
        <LocationSearch
          id="store-locator"
          variant="inline"
          initialValue={initialValue}
          onLocationSelect={handleStoreLookup}
          gtmEventSource="store-finder"
        />
      </div>
    </div>
  );
};

export default StoreHeader;
